import { combineReducers } from 'redux';
import { sarsaparillaReducers } from 'sarsaparilla';

import portalReducers from '../src/reducers';

const createRootReducer = combineReducers({
    portal: portalReducers,
    ...sarsaparillaReducers
});

export default createRootReducer;

